import React from 'react';
import { StartDateSelector } from './start-date-selector';
import { EndDateSelector } from './end-date-selector';
import { GradeVisibilityDropdown } from './grade-visibility-dropdown';
import { GradeSelectionDropdown } from './grade-selection-dropdown';

export const FilterBar = () => {
    return (
        <div style={{ display: 'flex'}}>
            <StartDateSelector />
            <EndDateSelector />
            <GradeVisibilityDropdown />
            <GradeSelectionDropdown />
        </div>
    );
};